import { HStack } from '@bpba/ui-components';
import { StyledSpan } from '../shared/StyledSpan';

type IconedLabelProps = {
  children: React.ReactNode;
  text: string;
  inverse: boolean;
} & React.HTMLAttributes<HTMLButtonElement>;

export const IconedLabel = (props: IconedLabelProps) => {
  if (props === null) return <></>;

  return (
    <>
      <StyledSpan color="white" fontWeight={400} fontSize={'18px'} {...props}>
        <HStack alignItems={'center'}>
          {props.inverse && props.children}
          <StyledSpan mx={'10px'} fontWeight="600" lineHeight={'20px'}>
            {props.text}
          </StyledSpan>
          {!props.inverse && props.children}
        </HStack>
      </StyledSpan>
    </>
  );
};
